module.exports = __webpack_public_path__ + "img/play-golf-fz-lle-logo.fbb31cdf.jpg";